module.exports = __webpack_public_path__ + "img/alarm-clock.bf1095b8.png";